import React from "react";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: props => ({
        backgroundColor: props.options.buttonColor,
        bottom: 0,
        padding: '10px 5px',
        width: '100%',
        borderRadius: props.radius,
        marginBottom: 5,
        maxWidth: 183
    }),
    label: props => ({
        color: props.options.buttonTextColor,
        fontSize: 14,
        margin: 0,
        textAlign: 'center',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    }),
}));

export default function BuyButtonCard({ colors, options }) {
    const classes = useStyles({ ...colors, radius: options.radius });

    return (
        <div className={classes.root}>
            <p className={classes.label}>
                {options?.textButton}
            </p>
        </div>
    );
};